import { render, staticRenderFns } from "./SkipToContentLink.vue?vue&type=template&id=1265a7ef&"
import script from "./SkipToContentLink.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SkipToContentLink.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports